import { useState } from 'react';
import type { VideoJob } from '../services/local-video';

/** Older exports can display their final overview frame without another GPU render. */
export function VideoOverview({ job }: { job: VideoJob }) {
  const [missing, setMissing] = useState(false);
  const [failed, setFailed] = useState(false);
  const [ready, setReady] = useState(false);
  if (job.state !== 'completed') return <div className="video-overview video-overview-pending">Overview available when your video is ready</div>;
  const label = `Complete route overview for ${job.title}`;
  return <div className="video-overview">
    {job.thumbnailUrl && !missing
      ? <img alt={label} src={job.thumbnailUrl} loading="lazy" onError={() => setMissing(true)} />
      : <><video aria-label={label} muted playsInline preload="metadata" tabIndex={-1}
          src={job.downloadUrl ?? `/api/local/renders/${job.id}/video`}
          style={{ opacity: ready ? 1 : 0 }}
          onLoadedMetadata={event => { const video = event.currentTarget; if (Number.isFinite(video.duration)) video.currentTime = Math.max(0, video.duration - 1 / 30); }}
          onError={() => setFailed(true)} onSeeked={() => setReady(true)} />
        {!ready && <span className="video-overview-loading">{failed ? 'Overview unavailable' : 'Loading route overview…'}</span>}</>}
  </div>;
}
